/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionWithAnswer
 */
export interface QuestionWithAnswer {
    /**
     * 
     * @type {number}
     * @memberof QuestionWithAnswer
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionWithAnswer
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionWithAnswer
     */
    readonly answer: string;
}

/**
 * Check if a given object implements the QuestionWithAnswer interface.
 */
export function instanceOfQuestionWithAnswer(value: object): value is QuestionWithAnswer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('answer' in value) || value['answer'] === undefined) return false;
    return true;
}

export function QuestionWithAnswerFromJSON(json: any): QuestionWithAnswer {
    return QuestionWithAnswerFromJSONTyped(json, false);
}

export function QuestionWithAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionWithAnswer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'text': json['text'],
        'answer': json['answer'],
    };
}

  export function QuestionWithAnswerToJSON(json: any): QuestionWithAnswer {
      return QuestionWithAnswerToJSONTyped(json, false);
  }

  export function QuestionWithAnswerToJSONTyped(value?: Omit<QuestionWithAnswer, 'id'|'answer'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

